import React from 'react'

export default function Label({
  label,
  forceLight = false,
  noRightPadding,
  noLabelPadding,
  showAsterisk,
  marginBottom = "mb-1"
}) {
  if (!label) return null

  return (
    <div className={`flex justify-between ${marginBottom} ${noRightPadding ? 'pl-4' : noLabelPadding ? '': 'px-4'}`}>
      <label className={`block text-sm font-medium text-rb-black ${forceLight ? '' : 'dark:text-rb-dark-mode-text-grey'}`}>
        {label}
        {showAsterisk && <span className="text-red-400">*</span>}
      </label>
    </div>
  )
}
